$(document).ready(function () {
    $('.stock-balance-print-options').on('show.bs.modal', function (event) {
        const form = $(this).find('form');
        form[0].reset();
        const filters = form.find('.stock-balance-print-filters').empty();
        const url = new URL($(event.relatedTarget).attr('href'), window.location.href);

        url.searchParams.forEach(function (value, name) {
            $('<input>', { type: 'hidden', name: name, value: value }).appendTo(filters);
        });
    });
});
